import React from 'react';
import { useLocation } from 'react-router-dom';
import { REGION } from '../config/region';
import { FOOTER } from '../config/content';
import { goToMarket, hrefFor } from '../utils/marketSwitch';
import styles from './Footer.module.css';

/**
 * "🇦🇺 Australia · 🇺🇸 United States" in the footer: the market being viewed
 * as plain text, every other one as a link to the same page on its site.
 * Rendered only when the site ships in more than one market.
 */
const MarketSwitcher: React.FC = () => {
  const { pathname } = useLocation();
  const markets = REGION.markets.list;
  if (markets.length < 2) return null;

  return (
    <nav className={styles.marketSwitcher} aria-label={FOOTER.marketSwitcherLabel}>
      {markets.map((m, i) => (
        <React.Fragment key={m.code}>
          {i > 0 && <span className={styles.marketSep} aria-hidden="true">·</span>}
          {m.code === REGION.code ? (
            <span className={styles.marketCurrent} aria-current="true" lang={m.hreflang}>
              <span aria-hidden="true">{m.flag}</span> {m.name}
            </span>
          ) : (
            <a
              className={styles.marketLink}
              href={hrefFor(m, pathname)}
              hrefLang={m.hreflang}
              onClick={(e) => goToMarket(e, m, hrefFor(m, pathname))}
            >
              <span aria-hidden="true">{m.flag}</span> {m.name}
            </a>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default MarketSwitcher;
